import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/lib/Button';
import Modal from 'react-bootstrap/lib/Modal';

import { validationModes } from '../../utils/verifier.utils';
import { ValidationModal } from './ValidationModal';
import { FormattedMessage } from 'react-intl';

class ValidationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      ticketValue: '',
      ticketGroupValidation: false,
      isTicketGroup: false,
      forceValidation: false,
      forceModal: false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleTicketValidation = this.handleTicketValidation.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  componentDidMount() {
    this.textInput.focus();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    if (name === 'forceValidation' && value) {
      this.setState({
        showModal: true,
        forceModal: true
      });
    }

    this.setState({
      [name]: value
    });
	  this.textInput.focus();
  }

  closeModal() {
    this.setState({ showModal: false, forceModal: false });
  }

  openModal(e) {
	  this.textInput.focus();
	  e.preventDefault();
	  if(this.textInput.value !== ''){
		  if (isNaN(this.textInput.value) && !this.state.ticketGroupValidation) {
			  this.handleTicketValidation();
		  } else {
			  this.setState({
				  showModal: true
			  });
		  }
    }

  }

  createValidationRequest(isTicketGroup, numTicketsToValidate) {
    let { forceValidation } = this.state;
    const ticketValue = this.textInput.value;

    const validationRequest = {
      ticketGroup: isTicketGroup,
      verifierId: this.props.verifierId,
      validationMode: forceValidation
        ? validationModes.override
        : validationModes.manual
    };

    if (numTicketsToValidate)
      validationRequest.numTicketsToValidate = numTicketsToValidate;

    isNaN(ticketValue)
      ? (validationRequest.barcode = ticketValue)
      : (validationRequest.ticketId = Number(ticketValue));

	  this.textInput.focus();


	  return validationRequest;
  }

  handleTicketValidation() {
    const validationRequest = this.createValidationRequest();
    this.props.ticketValidation(validationRequest);
    this.textInput.value = '';
    this.setState({
      ticketValue: ''
    });
  }

  handleIsTicketGrupal(isTicketGroup, numTicketsToValidate) {
    this.setState({ isTicketGroup: isTicketGroup });
    this.closeModal();
    let validationRequest = this.createValidationRequest(isTicketGroup, numTicketsToValidate);
    this.props.ticketValidation(validationRequest);
    this.textInput.value = '';
    this.setState({
      ticketValue: '',
    });
  }

  render() {
    const { ticketGroupValidation, forceValidation, showModal } = this.state;

    return (
      <div>
        <div>
          <h1><FormattedMessage id="title.verifier" defaultMessage="Validador"/></h1>
          <form className="form-inline form-custom">
            <div className="form-group col-md-10 col-lg-10 col-xs-12">
              <label className="sr-only"><FormattedMessage defaultMessage="Código a validar" id="label.code.validation"/> </label>
              <input
                autoFocus
                className="form-control input-custom"
                type="text"
                name="ticketValue"
                ref={input => {
                  this.textInput = input;
                }}
              />
            </div>
            <button
              className="btn btn-custom-scan"
              onClick={e => this.openModal(e)}
            >
              <span className="icon-own-barcode" />
              <FormattedMessage
                id="validator.button.scan"
                defaultMessage="scan"
              />
            </button>
          </form>

          <div className="form-inline">
            <div className="custom-checkbox">
              <input
                defaultChecked={ticketGroupValidation}
                name="ticketGroupValidation"
                onChange={this.handleInputChange}
                type="checkbox"
                id="ticketGroupValidation"
              />
              <label
                className="checkbox-inline"
                htmlFor="ticketGroupValidation"
              >
                <span> </span><FormattedMessage defaultMessage="Validación parcial grupos" id="label.partial.validation.groups" tagName={'n'}/>
              </label>
            </div>

            <div className="custom-checkbox">
              <input
                defaultChecked={forceValidation}
                name="forceValidation"
                onChange={this.handleInputChange}
                type="checkbox"
                id="forceValidation"
              />
              <label className="checkbox-inline" htmlFor="forceValidation">
                <span> </span>
                <FormattedMessage
                  id="validator.forceCheck"
                  defaultMessage="Forzar automáticamente al escanear"
                  tagName={'n'}
                />
              </label>
            </div>
          </div>
        </div>

        <Modal show={showModal} onHide={this.closeModal}>
          <Modal.Header closeButton />

          {this.state.forceModal ? (
            <div>
              <Modal.Body>
                <div className="form-group">
	                <FormattedMessage
                    defaultMessage="Se ha marcado la opción Forzar automáticamente al escanear. Todas las validaciones se forzarán hasta que se deshabilite esta opción."
                    id="text.modal.forceCheck"
                    tagName="p"/>

                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={this.closeModal}><FormattedMessage defaultMessage="Ok" id="button.ok"/></Button>
              </Modal.Footer>
            </div>
          ) : (
            <ValidationModal
              ticketGroupValidation={this.state.ticketGroupValidation}
              handleInputChange={this.handleInputChange}
              handleIsTicketGrupal={(isTicketGroup,numTicketsToValidate) =>
                this.handleIsTicketGrupal(isTicketGroup, numTicketsToValidate)
              }
            />
          )}
        </Modal>
      </div>
    );
  }
}

ValidationForm.propTypes = {
  ticketValidation: PropTypes.func.isRequired,
  verifierId: PropTypes.number.isRequired
};

export default ValidationForm;
